import { render, staticRenderFns } from "./PrivateTemplateItem.vue?vue&type=template&id=e9163a8c&"
import script from "./PrivateTemplateItem.vue?vue&type=script&lang=js&"
export * from "./PrivateTemplateItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports